import React, { useEffect, useMemo, useState } from "react";
import "./SolutionDetailsProducts.css";
import { resolveMediaUrl } from "../../../../utils/media";
import { useTranslation } from "react-i18next";
import { getMetalFrames } from "../../../../api/metalFrames";

// you will replace images
import fireImg from "../../../../assets/images/solutions/fire.png";
import fmrImg from "../../../../assets/images/solutions/fmr.png";
import exteriorImg from "../../../../assets/images/solutions/ext.png";

const products = [
    {
        title: "Fire",
        desc: "Fire Resistant (FR) gypsum board is a factory-manufactured, paper-faced gypsum plasterboard with a non-combustible core.",
        img: fireImg,
    },
    {
        title: "FMR",
        desc: "Fire & Moisture Resistant Gypsum Board (FMR) is a factory-manufactured, paper-faced gypsum plasterboard engineered for durability.",
        img: fmrImg,
    },
    {
        title: "Exterior",
        desc: "ShieldEx Glass Mat Gypsum Sheathing Board is an exterior-grade gypsum panel with fiberglass mat facings.",
        img: exteriorImg,
    },
];

const SolutionDetailsProducts = ({ solution }) => {
    const { i18n } = useTranslation();
    const [frameProducts, setFrameProducts] = useState([]);
    const solutionSlug = String(solution?.slug || "").toLowerCase();
    const isInteriorDrywallSolution = solutionSlug === "interior-drywall-system";
    const isCeilingSolution = solutionSlug === "ceiling-system";
    const frameType = isInteriorDrywallSolution
        ? "drywall-metal-frame"
        : isCeilingSolution
            ? "ceiling-metal-frame"
            : null;

    useEffect(() => {
        if (!frameType) return;
        let isMounted = true;
        const load = async () => {
            try {
                const data = await getMetalFrames({
                    language: String(i18n.language || "en").toLowerCase(),
                    frameType,
                });
                if (!isMounted) return;
                const normalized = (Array.isArray(data) ? data : [])
                    .map((item, idx) => ({
                        title: item?.name || item?.heroTitle || "",
                        desc: item?.heroDescription || "",
                        img:
                            resolveMediaUrl(item?.imageUrl) ||
                            products[idx % products.length]?.img,
                    }))
                    .filter((item) => item.title || item.desc || item.img);
                setFrameProducts(normalized);
            } catch {
                if (isMounted) setFrameProducts([]);
            }
        };
        load();
        return () => {
            isMounted = false;
        };
    }, [frameType, i18n.language]);

    const dynamicProducts = Array.isArray(solution?.products)
        ? solution.products
            .map((p, idx) => ({
                title: p?.title || "",
                desc: p?.description || p?.text || p?.body || "",
                img: resolveMediaUrl(p?.imageUrl || p?.image || p?.mediaUrl) || products[idx % products.length]?.img,
            }))
            .filter((p) => p.title || p.desc || p.img)
        : [];

    const list = useMemo(() => {
        if (frameType) {
            if (frameProducts.length) return frameProducts;
            if (dynamicProducts.length) return dynamicProducts;
            return products;
        }
        return dynamicProducts.length ? dynamicProducts : products;
    }, [frameType, frameProducts, dynamicProducts]);

    const productsTag = solution?.productsTag || "PRODUCTS";
    const productsTitle = solution?.productsTitle || "Product you can use in";
    const productsTitleAccent = solution?.productsTitleAccent || "exterior application";

    return (
        <section className="productsSection">
            <div className="productsContainer">

                {/* TAG */}
                <span className="productsTag">{productsTag}</span>

                {/* TITLE */}
                <h2 className="productsTitle">
                    {productsTitle} <br />
                    <span>{productsTitleAccent}</span>
                </h2>

            </div>

            {/* GRID */}
            <div className="productsGrid">
                {list.map((item, index) => (
                    <div key={index} className="productItem">

                        {/* IMAGE STACK */}
                        <div className="productImageWrapper">
                            <img src={item.img} alt={item.title} />
                        </div>

                        <div>
                            <h3>{item.title}</h3>
                            <p>{item.desc}</p>
                        </div>

                    </div>
                ))}
            </div>
        </section>
    );
};

export default SolutionDetailsProducts;